import { useFormik } from "formik";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Autocomplete from "react-google-autocomplete";
import DatePicker from "react-multi-date-picker";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { mapApiKey, otherInspection } from "../../Utils";
import {
  allPropertiesReducer,
  bookInspectionReducer,
} from "../../features/slice";
import Loader from "../Loader";
import TimePicker from "react-time-picker";

import { load } from "@cashfreepayments/cashfree-js";

function BuyPlanModal({ show, handleShow, packageId, detailPage }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [countryData, setCountryData] = useState();
  const [idBok, setIdBok] = useState("");
  const [loading, setLoading] = useState(false);
  const autocompleteRef = useRef();
  const detail = useSelector((store) => store.main.userDetail);
  const propertyList = useSelector((store) => store.main.allProperties);

  const [property, setProperty] = useState("");
  const [cms, setcms] = useState(false);

  const cashfree = (sessionId, bookingId) =>
    load({
      mode: "sandbox", //or production
    }).then((res) => {
      console.log(sessionId, "sessionId");
      res.checkout({
        paymentSessionId: sessionId,
        returnUrl: `${window.location.origin}/houzez/build/booking/detail/${bookingId}`,
      });
    });

  const initialValues = {
    preferredDate: "",
    userName: detail?.userName || "",
    address: "",
    long: "",
    lat: "",
    email: detail?.email || "",
    countryCode: detail?.countryCode || "",
    mobile: detail?.phoneNumber || "",
    propertyName: "",
    totalBuilt: "",
    otherInspectionDetails: otherInspection,
    propertyId: "",
    timeOfInspection: "10:00",
    apartmentNumber: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      userName: Yup.string().required("Required"),
      preferredDate: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      mobile: Yup.string().required("Required"),
      apartmentNumber: Yup.string().required("Required"),
      propertyId: cms === true ? null : Yup.string().required("Required"),
      propertyName: cms === true ? Yup.string().required("Required") : null,
      totalBuilt: Yup.string().required("Required"),
      otherInspectionDetails: Yup.array()
        .min(1, "Required")
        .required("Required"),
    }),
    enableReinitialize: true,
    onSubmit: (values, { isSubmitting, resetForm }) => {
      setLoading(true);

      const payload = {
        packageId: packageId,
        userName: values.userName,
        email: values.email,
        countryCode: values.countryCode,
        phoneNumber: values.mobile,
        propertyName: values.propertyName,
        otherInspectionDetails: values.otherInspectionDetails?.map((item) => {
          return {
            name: item?.name,
            status: item?.checked === true ? 1 : 0,
            iconUrl: item?.iconUrl,
          };
        }),
        location: values.address,
        apartmentNumber: values.apartmentNumber,
        area: values.totalBuilt.toString(),
        timeOfInspection: values.timeOfInspection,
        dateOfInspection: moment(values.preferredDate, "DD/MM/YYYY").format(
          "MM/DD/YYYY"
        ),
        // return_url: `${window.location.origin}/houzez/build/booking/return?order_id=${idBok}`,
      };

      const Mpayload = {
        packageId: packageId,
        userName: values.userName,
        email: values.email,
        countryCode: values.countryCode,
        phoneNumber: values.mobile,
        propertyId: values.propertyId,
        otherInspectionDetails: values.otherInspectionDetails?.map((item) => {
          return {
            name: item?.name,
            status: item?.checked === true ? 1 : 0,
            iconUrl: item?.iconUrl,
          };
        }),
        location: values.address,
        apartmentNumber: values.apartmentNumber,
        area: values.totalBuilt.toString(),
        timeOfInspection: values.timeOfInspection,
        dateOfInspection: moment(values.preferredDate, "DD/MM/YYYY").format(
          "MM/DD/YYYY"
        ),
        // return_url: `${window.location.origin}/houzez/build/booking/return?order_id=${idBok}`,
      };

      console.log(payload, Mpayload, "payload");

      if (values.propertyName) {
        dispatch(bookInspectionReducer(payload)).then((data) => {
          setLoading(false);
          if (data?.payload?.code === 1) {
            // toast.success(data.payload.message);
            cashfree(
              data.payload?.count?.payment_session_id,
              data.payload?.data?._id
            );
            // window.location.href = data?.payload?.count?.link_url;
          } else {
            setLoading(false);
            toast.error(data.payload.message);
          }
        });
      } else {
        dispatch(bookInspectionReducer(Mpayload)).then((data) => {
          setLoading(false);
          if (data?.payload?.code === 1) {
            // toast.success(data.payload.message);
            setIdBok(data.payload?.data?.bookingId);
            cashfree(
              data.payload?.count?.payment_session_id,
              data.payload?.data?._id
            );
            console.log(data);
            // window.location.href = data?.payload?.count?.link_url;
          } else {
            setLoading(false);
            toast.error(data.payload.message);
          }
        });
      }
    },
  });

  const colourStyles = {
    // control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        textTransform: "capitalize",
      };
    },
  };

  const getList = useCallback(() => {
    dispatch(allPropertiesReducer({}));
  }, [dispatch]);

  useEffect(() => {
    getList();
  }, [getList]);

  return (
    <Modal show={show} onHide={handleShow} centered size="md">
      <Modal.Body>
        <div className="position-relative mb-4">
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              handleShow();
            }}
          ></button>
          <h4
            className="text-center mb-1"
            onClick={() => {
              cashfree();
            }}
          >
            Buy Plan
          </h4>
          <p className="text-center mb-3">
            Lorem ipsum dolor sit amet, consectetueradipiscing elit. Aenean
            commodo ligula eget dolor. Aenean massa.
          </p>
          <div className="text-center">
            <img src="assets/images/Buyplan.png" className="img-fluid" alt="" />
          </div>
          <form className="form-style mt-5" onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group">
                  <div className="input-container">
                    <input
                      type="text"
                      className="form-control"
                      value={formik.values.userName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="userName"
                      placeholder="Name"
                    />
                    <img
                      src="assets/images/user.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.userName && formik.touched.userName && (
                    <div className="text-red"> {formik.errors.userName}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group">
                  <div className="input-container">
                    <input
                      type="email"
                      className="form-control"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="email"
                      placeholder="Email Address"
                    />
                    <img
                      src="assets/images/email.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.email && formik.touched.email && (
                    <div className="text-red"> {formik.errors.email}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-4">
                <div className="form-group">
                  <div className="input-container">
                    <PhoneInput
                      country="in"
                      inputProps={{
                        name: "mobile",
                      }}
                      enableSearch
                      value={formik.values.countryCode + formik.values.mobile}
                      onChange={(phone, country, e, formattedValue) => {
                        setCountryData({ formattedValue, country });
                        if (phone.length > 0) {
                          const raw = phone.slice(country?.dialCode?.length);
                          formik.setFieldValue("mobile", raw);

                          formik.setFieldValue(
                            "countryCode",
                            formattedValue?.split(" ")[0]
                          );
                        } else {
                          formik.setFieldValue("mobile", "");

                          formik.setFieldValue("countryCode", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      placeholder="Enter Phone Number"
                      containerclassName="form-control signupClass"
                      inputclassName="phoneInputClass"
                    />
                    <img
                      src="assets/images/phone.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.mobile && formik.touched.mobile && (
                    <div className="text-red"> {formik.errors.mobile}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
                <div className="form-group">
                  <div className="input-container">
                    <DatePicker
                      onChange={(val) => {
                        // console.log(val);
                        formik.setFieldValue("preferredDate", val.toString());
                      }}
                      value={formik.values.preferredDate}
                      inputClass="form-control"
                      calendarIcon={false}
                      // clearIcon={true}
                      format="DD/MM/YYYY"
                      placeholder="Preferred date of inspection"
                      name="preferredDate"
                      minDate={new Date()}
                    />
                    <img
                      src="assets/images/Calender.png"
                      className="input-img"
                      alt=""
                    />
                    <img
                      src="assets/images/Calendericn.png"
                      className="inputImgRight"
                      alt=""
                    />
                  </div>
                  {formik.errors.preferredDate &&
                    formik.touched.preferredDate && (
                      <div className="text-red">
                        {" "}
                        {formik.errors.preferredDate}
                      </div>
                    )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-4">
                <div className="form-group">
                  <div className="input-container">
                    <TimePicker
                      onChange={(val) => {
                        formik.setFieldValue(`timeOfInspection`, val);
                      }}
                      clockIcon={null}
                      disableClock={true}
                      clearIcon={null}
                      minutePlaceholder="MM"
                      hourPlaceholder="HH"
                      value={formik.values.timeOfInspection || undefined}
                      className={"form-control"}
                      name="timeOfInspection"
                      format="hh:mm a"
                    />
                    <img
                      src="assets/images/Calender.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group">
                  <div className="input-container">
                    <input
                      type="text"
                      className="form-control pl-5"
                      value={formik.values.apartmentNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="apartmentNumber"
                      placeholder="Apartment Number"
                    />
                    <img
                      src="assets/images/Area.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.apartmentNumber &&
                    formik.touched.apartmentNumber && (
                      <div className="text-red">
                        {" "}
                        {formik.errors.apartmentNumber}
                      </div>
                    )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group">
                  <div className="input-container">
                    <Autocomplete
                      apiKey={mapApiKey}
                      name="address"
                      className="form-control"
                      placeholder="Location"
                      value={formik.values.address}
                      ref={autocompleteRef}
                      onChange={() => {
                        // console.log(autocompleteRef);
                        formik.setFieldValue(
                          `address`,
                          autocompleteRef.current.value
                        );
                      }}
                      onPlaceSelected={(place, inputRef, autocompleteRef) => {
                        // console.log(place, inputRef, autocompleteRef);
                        if (place) {
                          let lat = place.geometry.location.lat();
                          let lng = place.geometry.location.lng();
                          let address = place.formatted_address;
                          formik.setFieldValue(`address`, address);
                          formik.setFieldValue(`long`, lng);
                          formik.setFieldValue(`lat`, lat);
                        }
                      }}
                      options={{
                        types: ["(regions)"],
                        componentRestrictions: { country: "in" },
                      }}
                    />
                    <img
                      src="assets/images/Location.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.address && formik.touched.address && (
                    <div className="text-red"> {formik.errors.address}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group">
                  <div className="input-container">
                    <select
                      className={
                        formik.values.propertyInCMS === true
                          ? "d-none"
                          : "form-control form-select text-capitalize"
                      }
                      value={formik.values.propertyId}
                      onChange={(e) => {
                        formik.setFieldValue("propertyId", e.target.value);
                        setProperty(e.target.value);
                      }}
                    >
                      <option value="">Select Property</option>
                      {propertyList?.data?.map((item, i) => (
                        <option value={item?._id} key={i}>
                          {item?.propertyName}
                        </option>
                      ))}
                      {/* <option value="Other">Other</option> */}
                    </select>
                    <input
                      type="text"
                      className={
                        formik.values.propertyInCMS === true
                          ? "form-control"
                          : "d-none"
                      }
                      value={formik.values.propertyName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="propertyName"
                      placeholder="Enter Property Name"
                    />
                    {/* <Select
                      className="form-control"
                      value={formik.values.propertyId || undefined}
                      styles={colourStyles}
                      onChange={(val) => {
                        formik.setFieldValue("propertyId", val);
                      }}
                      options={property || ""}
                      getOptionLabel={(option) => {
                        return (
                          `${
                            option?.propertyName?.charAt(0)?.toUpperCase() +
                            option?.propertyName?.slice(
                              1,
                              option?.propertyName.length
                            )
                          }`,
                          { propertyName: "d" }
                        );
                      }}
                      getOptionValue={(option) => option?._id}
                      // onInputChange={(e) => {
                      //   setProperty(e);
                      //   formik.setFieldValue("propertyId", {
                      //     propertyName: property,
                      //     _id: null,
                      //   });
                      // }}
                    /> */}
                    <img
                      src="assets/images/Property.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.values.propertyInCMS === true
                    ? formik.errors.propertyName &&
                      formik.touched.propertyName && (
                        <div className="text-red">
                          {" "}
                          {formik.errors.propertyName}
                        </div>
                      )
                    : formik.errors.propertyId &&
                      formik.touched.propertyId && (
                        <div className="text-red">
                          {" "}
                          {formik.errors.propertyId}
                        </div>
                      )}
                </div>
              </div>
              <div
                className={
                  formik.values.propertyId
                    ? "d-none"
                    : "col-sm-12 col-md-12 mb-3"
                }
              >
                <div className="nav nav-pills justify-content-start checkboxs1">
                  {/* <div className="nav-item m-0">
                      <input
                        id="PropertyIN CMS"
                        name={`propertyInCMS`}
                        type="radio"
                        value="inCMS"
                        onChange={(e) => {
                          formik.setFieldValue(`propertyInCMS`, e.target.value);
                        }}
                        onBlur={formik.handleBlur}
                        checked={
                          formik.values.propertyInCMS === "inCMS"
                            ? "checked"
                            : ""
                        }
                      />
                      <label htmlFor="PropertyIN CMS">Property In CMS</label>
                    </div> */}
                  <div className="nav-item m-0">
                    <input
                      id="PropertyNotCMS"
                      name={`propertyInCMS`}
                      type="checkbox"
                      // value={formik.values.propertyInCMS}
                      onChange={(e) => {
                        formik.setFieldValue(
                          `propertyInCMS`,
                          formik.values.propertyInCMS === false ? true : false
                        );
                        setcms(
                          formik.values.propertyInCMS === false ? true : false
                        );
                      }}
                      // onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.propertyInCMS === true}
                    />{" "}
                    <label htmlFor="PropertyNotCMS">Property not CMS</label>
                  </div>
                </div>
                {formik.errors.propertyInCMS &&
                  formik.touched.propertyInCMS && (
                    <div className="text-red">
                      {" "}
                      {formik.errors.propertyInCMS}
                    </div>
                  )}
              </div>
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group">
                  <div className="input-container">
                    <input
                      type="number"
                      className="form-control"
                      value={formik.values.totalBuilt}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="totalBuilt"
                      placeholder="Total Built -up Area"
                    />
                    <img
                      src="assets/images/Area.png"
                      className="input-img"
                      alt=""
                    />
                    <span className="inputImgRight">Sqft</span>
                  </div>
                  {formik.errors.totalBuilt && formik.touched.totalBuilt && (
                    <div className="text-red"> {formik.errors.totalBuilt}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="nav nav-pills justify-content-start checkboxs">
                  {formik.values?.otherInspectionDetails?.map((item, i) => (
                    <div className="nav-item m-0" key={i}>
                      <input
                        id={item?.name}
                        name={`otherInspectionDetails.[${i}].checked`}
                        type="checkbox"
                        value={item?.name}
                        onChange={(e) => {
                          let checked = e.target.checked;

                          formik.setFieldValue(
                            `otherInspectionDetails.[${i}].checked`,
                            checked
                          );
                        }}
                        onBlur={formik.handleBlur}
                        checked={item?.checked}
                      />
                      <label htmlFor={item?.name}>
                        <img src={item?.iconUrl} alt="" className="iconsSize" />{" "}
                        {item?.name}
                      </label>
                    </div>
                  ))}
                </div>
                {formik.errors.otherInspectionDetails &&
                  formik.touched.otherInspectionDetails && (
                    <div className="text-red">
                      {" "}
                      {formik.errors.otherInspectionDetails}
                    </div>
                  )}
              </div>
              <div className="col-sm-12 col-md-12 text-center">
                <button type="submit" className="btn btn-save w-50">
                  {loading ? <Loader /> : "Checkout"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default BuyPlanModal;
